/** @format */

import { Locale } from '@common/model/apiClient/Locale';
import { useQuery } from '@tanstack/react-query';

function UseLocales() {
  const localesQuery = useQuery({
    queryKey: ['locales_with_currency_not_deleted'],
    queryFn: () => Locale.list(),
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    refetchInterval: false,
  });

  const uniqueCodes = new Set((localesQuery.data?.payload ?? []).map?.((locale) => locale.countryId) ?? []);

  const localesData = (localesQuery.data?.payload ?? []).map?.((l) => {
    return {
      bcp47: l.bcp47,
      countryId: l.countryId,
      defaultCurrencyId: l?.defaultCurrencyId,
      description: l.description,
      microsoftLanguageCode: l.microsoftLanguageCode,
      nativeDescription: l.nativeDescription,
    };
  });

  const countryAlphaCodes = Array.from(uniqueCodes);

  return { localesData, countryAlphaCodes };
}

export default UseLocales;
